import React from "react";
import { useSelector } from "react-redux";

const InfoIcon = () => {
  const [whiteLabel] = useSelector((state: any) => [
    state.authReducer.preAuthDetails.whiteLabel,
  ]);

  const primary = whiteLabel?.primarycolor ?? "#606ac1";
  const secondary = whiteLabel?.secondarycolor ?? "#e300b1";

  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
        fill="url(#paint0_linear_2943_19299)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12C11 11.4477 11.4477 11 12 11Z"
        fill="url(#paint1_linear_2943_19299)"
      />
      <path
        d="M12 8H12.01"
        stroke="url(#paint2_linear_2943_19299)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2943_19299"
          x1="7.35052"
          y1="18.3462"
          x2="24.1864"
          y2="17.5032"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={primary} />
          <stop offset="1" stopColor={secondary} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2943_19299"
          x1="11.5773"
          y1="15.7308"
          x2="13.1113"
          y2="15.7052"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={primary} />
          <stop offset="1" stopColor={secondary} />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2943_19299"
          x1="12.0029"
          y1="8.78846"
          x2="12.0106"
          y2="8.78846"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={primary} />
          <stop offset="1" stopColor={secondary} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default InfoIcon;
